<template>
    <div class="time-line-container" v-infinite-scroll="load"  infinite-scroll-disabled="disabled" infinite-scroll-immediate="false">
        <el-timeline>
            <TimeLineItem v-for="(item, index) in timelineData"
                :key="index"
                :item="item"                
                @showDetail="showDetail"></TimeLineItem>
        </el-timeline>
        <div class="loading" v-if="loading">加载中...</div>
        <div class="nomore" v-if="noMore && timelineData.length>20">没有更多了</div>
    </div>
</template>

<script>
import TimeLineItem from './TimeLineItem';

export default {
    props: {
        timelineData: Array,
        loadMoreStatus: String,
    },
    components: {
        TimeLineItem,
    },
    methods: {
        showDetail: function (code) {
            this.$emit('showDetail', code);
        },
        load () {
            this.$emit('loadMore');
        }
    },
    computed: {
        disabled () {
            return this.loading || this.noMore
        },
        loading () {
            return this.loadMoreStatus === 'loading';
        },
        noMore () {
            return this.loadMoreStatus === 'noMore';
        }
    }
}
</script>

<style lang="less" scoped>
.time-line-container {
    overflow: hidden;
    overflow-y: scroll;
    white-space: nowrap;
    .h(352);
    width: 100%;

    //火狐隐藏滚动条
    scrollbar-width: none;

    .loading, .nomore {
        display: flex;
        justify-content: center;
        .h(50)
    }
}
::-webkit-scrollbar {
    display: none;
}
</style>